<template>
  <div class="animated fadeIn" id="bloquear-competencia">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-ban"></i> Bloqueio de Competencias
      </div>
      <div class="card-body">
        <h3 v-if="data" style="text-align: center; margin-bottom: 35px;">
          <i class="icon-calendar"></i> {{ meses[new Date(data).getMonth()] }}/{{ new Date(data).getFullYear() }}
        </h3>

        <div class="row">
          <div class="col-md-4">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width: 130px;">Data do Bloqueio</span>
              </div>
              <!-- Datepicker -->
              <date-picker input-class="form-control"
                           v-model="data"
                           lang="pt-br"
                           format="DD/MM/YYYY"
                           style="width: calc(100% - 130px);">
              </date-picker>
            </div>
          </div>
        </div>

        <div class="row" style="margin-bottom: 30px;">
          <div class="col-md-4">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Hora do Bloqueio</span>
              </div>
              <input type="time" class="form-control" v-model="hora">
            </div>
          </div>
        </div>

        <div class="row" v-if="competencia.id">
          <div class="col-md-12">
            <span style="color: red;">* A data para fechamento desta competência está definida para dia {{ formatarDataHora(competencia.datahora_bloqueio) }}</span>
          </div>
        </div>

        <button class="btn btn-primary pull-right" :disabled="!valoresValidos" v-on:click="salvar">
          <i class="icon-check"></i> Salvar
        </button>
        <button class="btn btn-default pull-right" style="margin-right: 5px;" v-on:click="voltar">
          <i class="icon-action-undo"></i> Cancelar
        </button>
      </div>
    </div>

    <notifications group="bloquear-competencia" />
  </div>
</template>

<style lang="scss">
  // #bloquear-competencia {
    // Estilos
  // }
</style>

<script>
import DatePicker from 'vue2-datepicker';
import Timepicker from 'vue2-timepicker';
import Uteis from '@/mixins/utils.js';
import { throws } from 'assert';

export default {
  components: {
    DatePicker,
    Timepicker,
  },

  mixins: [
    Uteis,
  ],

  data() {
    return {
      data: new Date(),
      hora: '',
      competencia: {},
      meses: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ],
    };
  },

  computed: {
    valoresValidos() {
      return this.data && this.hora && this.hora !== '00:00';
    },

    mes() {
      return `${this.data.getMonth()}/${this.data.getFullYear()}`;
    },
  },

  mounted() {
    this.pesquisarCompetencia();
  },

  watch: {
    mes() {
      this.pesquisarCompetencia();
    }
  },

  methods: {
    async salvar() {
      try {
        this.$events.$emit('loading', true);

        const { data: response } = await this.$http.post('/competencia', this.getDTO());

        if (response.success || response.id) {
          return this.notificar('Bloqueio agendado com sucesso!', 'bloquear-competencia', 'success');
        }

        throw new Error(response.message);
      } catch(e) {
        this.notificar('Ocorreu um erro ao salvar a Competência', 'bloquear-competencia');
      } finally {
        this.$events.$emit('loading', false);
        this.pesquisarCompetencia();
      }
    },

    getDTO() {
      return {
        id: this.competencia.id || null,
        mes: new Date(this.data).getMonth() + 1,
        ano: new Date(this.data).getFullYear(),
        datahora_bloqueio: `${new Date(this.data).toLocaleDateString()} ${this.hora}`,
      };
    },

    async pesquisarCompetencia() {
      try {
        this.$events.$emit('loading', true);

        const dto = {
          mes: new Date(this.data).getMonth() + 1,
          ano: new Date(this.data).getFullYear(),
        };

        const { data: response } = await this.$http.get('/competencia', { params: { filter: dto }});

        if (response.success) {
          return this.competencia = response.competencias[0];
        }

        this.competencia = {};
      } catch(e) {
        console.error(e);
        this.notificar('Ocorreu um erro ao carregar a Competência', 'bloquear-competencia');
      } finally {
        this.$events.$emit('loading', false);
      }
    },

    voltar() {
      this.$router.push({ path: '/' });
    },

    formatarDataHora(value) {
      return new Date(value).toLocaleString();
    },
  },
  // Elemento VUE
}
</script>
